// extracted by mini-css-extract-plugin
export default {"list":"styles_list__5PdOW","empty":"styles_empty__4tWb2"};